import { Platform } from "react-native";
import { loadClockState, saveClockState } from "./storage";

let TaskManager: typeof import("expo-task-manager");
let BackgroundFetch: typeof import("expo-background-fetch");


const BACKGROUND_TASK = "time-tracking-background-task";


if (Platform.OS !== "web") {
  TaskManager = require("expo-task-manager");
  BackgroundFetch = require("expo-background-fetch");

  TaskManager.defineTask(BACKGROUND_TASK, async () => {
    const state = await loadClockState();

    if (!state || !state.clockInTime) {
      return BackgroundFetch.BackgroundFetchResult.Failed;
    }

    const now = Date.now();
    const timePassed = Math.floor((now - state.lastSavedTime) / 1000);

    await saveClockState({
      ...state,
      lastElapsedTime: state.lastElapsedTime + timePassed,
      lastSavedTime: now,
    });

    return BackgroundFetch.BackgroundFetchResult.NewData;
  });
}

export async function registerBackgroundTask() {
  if (Platform.OS === "web") {
    console.log("⚠️ Background tasks are not supported on web (PWA).");
    return;
  }

  const status = await BackgroundFetch.getStatusAsync();
  if (status !== BackgroundFetch.BackgroundFetchStatus.Available) {
    console.log("⛔ Background Fetch permissions denied or unavailable");
    return;
  }

  try {
    await BackgroundFetch.registerTaskAsync(BACKGROUND_TASK, {
      minimumInterval: 60, // 🔁 Run every 60 seconds
      stopOnTerminate: false,
      startOnBoot: true,
    });
    console.log("✅ Background Task Registered");
  } catch (err) {
    console.error("❌ Failed to register background task:", err);
  }
}